
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/own-your-city/[cityName]/[cityId]",
      function () {
        return require("private-next-pages/play/own-your-city/[cityName]/[cityId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/own-your-city/[cityName]/[cityId]"])
      });
    }
  